import React from "react";

export const usePreventUnload = (isDirty: boolean, onFlush?: () => void): void => {
    const dirtyRef = React.useRef(isDirty);
    dirtyRef.current = isDirty;
    const flushRef = React.useRef(onFlush);
    flushRef.current = onFlush;
    React.useEffect(() => {
        const handler = (e: BeforeUnloadEvent) => {
            if (dirtyRef.current) {
                flushRef.current?.();
                e.preventDefault();
                e.returnValue = "";
            }
        };
        window.addEventListener("beforeunload", handler);
        return () => {
            flushRef.current?.();
            window.removeEventListener("beforeunload", handler);
        };
    }, []);
};
